<input type="checkbox" id="findMatchDiacritics" class="toolbarField" tabindex="96" />
<label for="findMatchDiacritics" class="toolbarLabel" data-l10n-id="pdfjs-find-match-diacritics-checkbox-label">Match Diacritics</label>
